import PageNester from '@/components/PageNester.vue';
import ToolsPage from './ToolsPage.vue';
import MyCharacters from './MyCharacters/MyCharacters.vue';
import Characters from './MyCharacters/Character.vue';
import CharacterPrint from './MyCharacters/CharacterPrint/CharacterPrint.vue';
export default {
    path: '/tools',
    component: PageNester,
    children: [
        {
            path: '/tools',
            component: ToolsPage,
            meta: {
                title: 'Tools'
            }
        },
        {
            path: '/tools/mycharacters',
            component: MyCharacters,
            props: ({ query }) => query,
            meta: {
                title: 'Character Creator'
            }
        },
        {
            path: '/tools/mycharacters/:characterId',
            component: Characters,
            props: ({ params, query }) => ({ ...params, ...query }),
            meta: {
                title: 'Character Creator'
            }
        },
        {
            path: '/tools/mycharacters/:characterId/print',
            component: CharacterPrint,
            props: true,
            meta: {
                title: 'Print Character Sheet'
            }
        }
    ]
};
